import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=3dafd9b6&scoped=true&"
import script from "./PartnerCard.vue?vue&type=script&lang=js&"
export * from "./PartnerCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=3dafd9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafd9b6",
  null
  
)

export default component.exports